/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Inactive_Use_BlockedInputs */

const cs_templates_inactive_use_blocked = /** @type {(inputs: Templates_Inactive_Use_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neaktivní šablonu nelze použít. Nejdřív ji aktivujte.`)
};

const en_templates_inactive_use_blocked = /** @type {(inputs: Templates_Inactive_Use_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive templates cannot be used. Activate first.`)
};

/**
* | output |
* | --- |
* | "Inactive templates cannot be used. Activate first." |
*
* @param {Templates_Inactive_Use_BlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_inactive_use_blocked = /** @type {((inputs?: Templates_Inactive_Use_BlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Inactive_Use_BlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_inactive_use_blocked(inputs)
	return cs_templates_inactive_use_blocked(inputs)
});